var lastSync;

function refreshSession() {
    if (!lastSync || Date.now() - lastSync > 1740000) {
        $.ajax({
            url: $('[data-refresh-session-url]').data('refresh-session-url'),
            method: 'GET'
        });
        lastSync = Date.now();
    }
}

module.exports = {
    refreshSession: refreshSession
};
